import ViolationsTabDetailsSidePanel from './ViolationsTabDetailsSidePanel';

export default ViolationsTabDetailsSidePanel;
